import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosInstance } from '../../../utils/axios';

// Obtener listado de reglas
export const fetchLiquidacionReglas = createAsyncThunk(
  'liquidacionReglas/fetchLiquidacionReglas',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('api/v1/collections/configuration-early-settlement/');
      return response.data;
    } catch (error) {
      if (error.response?.data) return rejectWithValue(error.response.data);
      return rejectWithValue(error.message);
    }
  }
);

// Crear nueva regla
export const createLiquidacionRegla = createAsyncThunk(
  'liquidacionReglas/createLiquidacionRegla',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('api/v1/collections/configuration-early-settlement/', data);
      return response.data;
    } catch (error) {
      if (error.response?.data) return rejectWithValue(error.response.data);
      return rejectWithValue(error.message);
    }
  }
);

// Actualizar regla
export const updateLiquidacionRegla = createAsyncThunk(
  'liquidacionReglas/updateLiquidacionRegla',
  async ({ uuid, data }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`api/v1/collections/configuration-early-settlement/${uuid}/`, data);
      return response.data;
    } catch (error) {
      if (error.response?.data) return rejectWithValue(error.response.data);
      return rejectWithValue(error.message);
    }
  }
);

// Borrar regla
export const deleteLiquidacionRegla = createAsyncThunk(
  'liquidacionReglas/deleteLiquidacionRegla',
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`api/v1/collections/configuration-early-settlement/${uuid}/`);
      return { uuid, ...response.data };
    } catch (error) {
      if (error.response?.data) return rejectWithValue(error.response.data);
      return rejectWithValue(error.message);
    }
  }
);

// --- SLICE ---
const liquidacionReglasSlice = createSlice({
  name: 'liquidacionReglas',
  initialState: {
    reglasList: { results: [] },
    isLoading: false,
    listLoading: false,
    error: null,
    listError: null,
    success: false,
    updateSuccess: false,
  },
  reducers: {
    resetLiquidacionReglasState: (state) => {
      state.isLoading = false;
      state.listLoading = false;
      state.error = null;
      state.listError = null;
      state.success = false;
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // --- FETCH ---
      .addCase(fetchLiquidacionReglas.pending, (state) => {
        state.listLoading = true;
        state.listError = null;
      })
      .addCase(fetchLiquidacionReglas.fulfilled, (state, action) => {
        state.listLoading = false;
        state.reglasList = action.payload;
      })
      .addCase(fetchLiquidacionReglas.rejected, (state, action) => {
        state.listLoading = false;
        state.listError = action.payload || 'Error al obtener reglas.';
      })

      // --- CREATE ---
      .addCase(createLiquidacionRegla.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createLiquidacionRegla.fulfilled, (state, action) => {
        state.isLoading = false;
        state.reglasList = action.payload.results ?? [];
        state.success = true;
      })
      .addCase(createLiquidacionRegla.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Error al crear regla.';
        state.success = false;
      })

      // --- UPDATE ---
      .addCase(updateLiquidacionRegla.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateLiquidacionRegla.fulfilled, (state, action) => {
        state.isLoading = false;
        state.reglasList = action.payload.results ?? [];
        state.success = true;
      })
      .addCase(updateLiquidacionRegla.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Error al actualizar regla.';
        state.success = false;
      })

      // --- DELETE ---
      .addCase(deleteLiquidacionRegla.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteLiquidacionRegla.fulfilled, (state, action) => {
        state.isLoading = false;
        state.reglasList = action.payload.results ?? [];
      })
      .addCase(deleteLiquidacionRegla.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Error al borrar regla.';
      });
  },
});

export const { resetLiquidacionReglasState } = liquidacionReglasSlice.actions;
export default liquidacionReglasSlice.reducer;
